"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(a) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    S = _interopRequireWildcard(require("./styles"));

function _getRequireWildcardCache() {
  if ("function" != typeof WeakMap) return null;
  var a = new WeakMap();
  return _getRequireWildcardCache = function _getRequireWildcardCache() {
    return a;
  }, a;
}

function _interopRequireWildcard(a) {
  if (a && a.__esModule) return a;
  if (null === a || "object" !== _typeof(a) && "function" != typeof a) return {
    "default": a
  };

  var b = _getRequireWildcardCache();

  if (b && b.has(a)) return b.get(a);
  var c = {},
      d = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var e in a) {
    if (Object.prototype.hasOwnProperty.call(a, e)) {
      var f = d ? Object.getOwnPropertyDescriptor(a, e) : null;
      f && (f.get || f.set) ? Object.defineProperty(c, e, f) : c[e] = a[e];
    }
  }

  return c["default"] = a, b && b.set(a, c), c;
}

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

var _default = function _default(a) {
  var b = a.columns,
      c = void 0 === b ? 1 : b,
      d = a.children;
  return _react["default"].createElement(S.List, null, _react["default"].Children.map(d, function (a) {
    return _react["default"].createElement(S.ListItem, {
      columns: c
    }, a);
  }));
};

exports["default"] = _default;